import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import modalPlugin from './plugins/modalPlugin';
import * as DIRECTIVES from '@/directives';
import FILTERS from '@/filters';
import * as UTILS from '@/utils';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/swiper-bundle.css';
import '@/assets/css/style.css';
import 'vue-advanced-chat';

import "wicg-inert";

import 'toastr/build/toastr.min.css';
import toastr from 'toastr';

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 4000,
    extendedTimeOut: 1000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};
window.toastr = toastr;

import moment from 'moment';
import { LocalizationServices } from './services/LocalizationServices';
moment.locale("IT-it");

const app = createApp(App)
    .use(store)
    .use(router)
    .use(modalPlugin)
    .directive('date', DIRECTIVES.date)

app.config.globalProperties.$filters = FILTERS;
app.config.globalProperties.$localizationServices = LocalizationServices;
app.config.globalProperties.$utility = UTILS;

const ComponentContext = require.context('./components', true, /\.vue$/i);
ComponentContext.keys().forEach(fileName => {
    var component = ComponentContext(fileName);
    let componentName = fileName.split('/').pop().split('.')[0];
    app.component(componentName, (<any>component).default || component);
})

app.mount('#app');
